import { createStyles } from 'antd-style';

import { FA_SELECTOR } from '../styles/variables';

export const useAddressesStyles = createStyles(({ token }) => ({
  zipCodeInput: {
    '.ant-form-item-explain': {
      width: 0,
      whiteSpace: 'nowrap',
    },
    '.ant-input': {
      width: 130,
    },
  },
  addressRowIcon: {
    color: token.colorPrimary,

    [FA_SELECTOR]: {
      fontSize: 21,
    },
  },
}));
